import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
const Notices = (param)=>{
    let { notices } = param;
    return /*#__PURE__*/ _jsx(_Fragment, {
        children: notices == null ? void 0 : notices.filter(Boolean).map((param)=>{
            let { message, severity, nop, key } = param;
            return message ? severity ? /*#__PURE__*/ _jsx("div", {
                className: `notice notice-${severity} below-h2 notice-alt`,
                style: {
                    margin: "10px 0px 0px"
                },
                children: typeof message === "string" ? message.startsWith("<p>") || nop ? /*#__PURE__*/ _jsx("span", {
                    dangerouslySetInnerHTML: {
                        __html: message
                    }
                }) : /*#__PURE__*/ _jsx("p", {
                    dangerouslySetInnerHTML: {
                        __html: message
                    }
                }) : nop ? message : /*#__PURE__*/ _jsx("p", {
                    children: message
                })
            }, key || message) : message : null;
        })
    });
};
export { Notices };
